import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { getSalarySlip } from "./employee_halper";
import { useNavigate } from "react-router-dom";
import Loading1 from "../frames/loading1";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import HtmlTooltip from "../frames/html_tooltip";

function SalarySlip() {
    const [salarySlip, setSalarySlip] = useState(null);
    const navigator = useNavigate();

    const initData = async (auth) => {
        if (!auth) return;
        setSalarySlip(await getSalarySlip());
    }

    const searchEmployee = (event) => {

    }

    return (
        <MenuFrame permission="EMPLOYEE" screen="SALARY_SLIP" onInit={initData} onSearch={searchEmployee}>
            <br />
            {salarySlip === null ? <Loading1 /> :
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="Salary Payment" className="nowrap">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                <TableCell>Date</TableCell>
                                <TableCell>Transaction Number</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Pay Cycle</TableCell>
                                <TableCell>Working Days</TableCell>
                                <TableCell align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {salarySlip.map((row) => (
                                <TableRow
                                    key={row.pay_id}
                                    onClick={() => { navigator("/accounts/transaction/" + row.emp_ref) }}
                                >
                                    <TableCell><Typography variant="body2">{row.pay_time}</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{row.transaction_num}</Typography></TableCell>
                                    <TableCell>
                                        <HtmlTooltip title={<>
                                            <Typography variant="caption">
                                                @{row.user_id}
                                            </Typography>
                                            <Typography variant="body1">
                                                #{row.emp_ref}
                                            </Typography>
                                        </>}>
                                            <Typography variant="body2">{row.name}</Typography>
                                        </HtmlTooltip>
                                    </TableCell>
                                    <TableCell><Typography variant="body2">{row.pay_cycle}</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{row.working_days}</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{row.amount}</Typography></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </MenuFrame>
    );
}

export default SalarySlip;
